import { useState } from 'react'
import { NavLink } from 'react-router-dom'
import styled from 'styled-components'

import playStoreBlackIcon from '@/assets/images/icon_playstore.png'
import playStoreWhiteIcon from '@/assets/images/icon_playstore_w.png'
import logoImg from '@/assets/images/logo.png'
import storeQRImg from '@/assets/images/qr_store.png'
import NavBar from '@/shared/components/layout/Navbar'
import { REMOTE_URL, STORE_URL } from '@/shared/constants'
import { Nanum_eb_size, Nanum_r_size } from '@/styles/font/NanumSquare'
import { mediaMobile, mediaTablet } from '@/styles/mediaQuery'
import { icoSet } from '@/styles/mixins'

const Header = () => {
  const [showQr, setShowQr] = useState(false)

  return (
    <HeaderWrap>
      <ServiceLogo to={'/home'}>
        <LogoImg src={logoImg} alt="Mfinder logo" />
      </ServiceLogo>
      <MenuWrap>
        <MenuBtnGroup>
          <PlayStoreWrap>
            <PlayStoreBtn onClick={() => setShowQr((prev) => !prev)}>앱 다운로드</PlayStoreBtn>
            {showQr && (
              <StoreQRWrap>
                <QRImg src={storeQRImg} />
                <PlayStoreLink target="_blank" href={STORE_URL}>
                  플레이스토어
                </PlayStoreLink>
              </StoreQRWrap>
            )}
          </PlayStoreWrap>
          <LoginBtn target="_blank" href={REMOTE_URL}>
            분실폰찾기 로그인
          </LoginBtn>
        </MenuBtnGroup>
        <NavBar />
      </MenuWrap>
    </HeaderWrap>
  )
}

export default Header
const LogoImg = styled.img`
  width: 170px;
  height: 30px;

  ${mediaTablet} {
    width: 136px;
    height: 24px;
  }
  ${mediaMobile} {
    width: 113px;
    height: 20px;
  }
`
const HeaderWrap = styled.header`
  z-index: 10;
  height: 110px;
  width: 100%;
  display: flex;
  align-items: center;
  padding: 29px 41px 31px 29px;
  justify-content: space-between;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;

  ${mediaTablet} {
    background-color: var(--white);
    height: 60px;
    padding: 13px 26px;
  }
`
const ServiceLogo = styled(NavLink)``
const MenuBtnGroup = styled.div`
  display: flex;
  gap: 10px;
`
const MenuWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`
const PlayStoreBtn = styled.button`
  background-color: var(--black);
  color: var(--white);
  padding: 12px 26px;

  ${Nanum_eb_size(20)}
  border-radius: 6px;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.3);
  ${mediaTablet} {
    ${Nanum_eb_size(14)}
  }

  &:before {
    content: '';
    display: inline-block;
    vertical-align: middle;
    width: 17px;
    height: 18px;
    margin-right: 7px;
    background-image: url(${playStoreWhiteIcon});
  }

  ${mediaTablet} {
    display: none;
  }
`
const PlayStoreWrap = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
`
const StoreQRWrap = styled.div`
  position: absolute;
  margin-top: 8px;
  top: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: var(--white);
  border-radius: 8px;
  padding: 14px 13px 18px;
  align-items: center;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.3);

  ${mediaTablet} {
    display: none;
  }
`
const QRImg = styled.img``

const PlayStoreLink = styled.a`
  padding: 9px 18px;
  border-radius: 25px;
  margin-top: 16px;
  border-radius: 25px;
  border: 1px solid var(--gray-bb);
  white-space: nowrap;
  ${Nanum_r_size(16)}

  &:before {
    content: '';
    display: inline-block;
    vertical-align: middle;
    width: 16px;
    height: 17px;
    margin-right: 5px;
    background-image: url(${playStoreBlackIcon});
    ${icoSet}
  }
`

const LoginBtn = styled.a`
  ${Nanum_eb_size(20)}
  border-radius: 6px;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.3);
  background-color: var(--white);
  ${mediaTablet} {
    ${Nanum_eb_size(14)}
  }

  padding: 12px;
  ${mediaTablet} {
    padding: 9px 13px;
  }
`
